import React, { Component } from 'react';

export default class StatusBarDisplayPeriod extends Component {
    constructor(props) {
        super(props);

        this.state = {
            label: props.initialLabel || '',
            entityName: props.entityName || 'fixtures',
        };
    }

    setLabel(label) {
        this.setState({ label });
    }

    isVisible() {
        return !!this.state.label;
    }

    render() {
        if (!this.state.label) {
            return null;
        }

        return (
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    height: '100%',
                    fontSize: '12px',
                    fontWeight: 500,
                    color: 'var(--ag-secondary-foreground-color, inherit)',
                }}
            >
                {`Displaying ${this.state.entityName} from ${this.state.label}`}
            </div>
        );
    }
}
